<template>
  <div>
    <v-row class="mt-3">
      <v-col cols="2">
        <date-field v-model="form.from" label="From Date" />
      </v-col>
      <v-col cols="2">
        <date-field v-model="form.to" label="To Date" />
      </v-col>
      <v-col cols="3" class="pt-10 d-flex">
        <close-button width="100px" @click="resetFilter()">Reset</close-button>
        <primary-button width="100px" @click="fetchTransactions()"
          >Apply</primary-button
        >
      </v-col>
    </v-row>
    <static-table-view :list="list" :headers="headers">
      <template v-slot:item.startWeek="{ item }"> {{ item.weekName }}</template>
      <template v-slot:item.total="{ value, item }">
        <referral-weekly-commissions-breakdown
          :transaction="item"
          :referral="referral"
          :value="value"
        />
      </template>
    </static-table-view>
  </div>
</template>

<script>
import {getHeaders, getStartEndDate} from "@/assets/utils/common.utils";
import PrimaryButton from "@/components/ui/buttons/PrimaryButton.vue";
import DateField from "@/components/ui/form/DateField.vue";
import {getDocs, limit, orderBy, query, where} from "firebase/firestore";
import {colTransactions, isLocal} from "@/assets/utils/firebase.utils";
import {fetchTransactionClients, mapDocs} from "@/assets/utils/doc.utils";
import CloseButton from "@/components/ui/buttons/CloseButton.vue";
import moment from "moment-timezone";
import StaticTableView from "../ui/StaticTableView.vue";
import ReferralWeeklyCommissionsBreakdown from "@/components/referrals/ReferralWeeklyCommissionsBreakdown.vue";

const defaultMonth = isLocal ? 12 : 3;
export default {
  props: {
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ReferralWeeklyCommissionsBreakdown,
    DateField,
    PrimaryButton,
    CloseButton,
    StaticTableView,
  },
  data() {
    return {
      dialog: false,
      isLoading: true,
      loading: false,
      list: [],
      transactionCount: 0,
      detectedFrom: null,
      form: {
        from: moment().subtract(defaultMonth, "months").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
        payout: "",
      },
    };
  },
  computed: {
    referralId() {
      return this.$route.params.id;
    },
    headers() {
      let doc = {
        startWeek: "Week Start - Week End",
        client_name: "Client Name",
        total: "Total Transaction Amount",
      };
      return getHeaders(doc);
    },
  },
  methods: {
    resetFilter() {
      this.form = {
        from: this.detectedFrom || moment().subtract(defaultMonth, "months").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
        payout: "",
      };
      this.fetchTransactions();
    },
    query() {
      let queryList = [];
      let { start, end } = getStartEndDate(this.form);
      queryList.push(orderBy("created_at", "desc"));
      if (start && end) {
        queryList.push(where("created_at", ">=", start));
        queryList.push(where("created_at", "<=", end));
      }
      queryList.push(where("referral_id", "==", this.referralId));
      return query(colTransactions, ...queryList);
    },
    async fetchTransactions() {
      try {
        this.loading = true;
        let docs = (await getDocs(this.query())).docs;
        this.firstVisible = docs[0];
        this.lastVisible = docs[docs.length - 1];
        let transactions = mapDocs(docs);
        this.transactionCount = transactions.length;
        transactions = await fetchTransactionClients(transactions);
        let start = moment(this.form.from);
        let end = moment(this.form.to).endOf("week");
        let weeks = end.diff(start, "weeks") + 1;
        let list = [];
        for (let i = 0; i < weeks; i++) {
          let startWeek = moment(start).add(i, "isoWeek").startOf("week");
          let endWeek = moment(start).add(i, "isoWeek").endOf("week");
          let history = transactions.filter((i) => {
            let date = moment(i.created_date);
            return date.isAfter(startWeek) && date.isBefore(endWeek);
          });
          let total = history.reduce((a, item) => {
            return Number(item.amount) + a;
          }, 0);
          const clientNames = [...new Set(history.map(i => i.client_name))];
          if (total !== 0) {
            list.push({
              weekName: `${startWeek.format("MMM DD YYYY")} - ${endWeek.format(
                "MMM DD YYYY"
              )}`,
              client_name: clientNames.join(", "),
              history,
              total,
              startWeek: startWeek.format(),
            });
          }
        }
        this.list = list.reverse();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
  },
  async mounted() {
    await this.fetchTransactions();
    if (this.transactionCount < 50) {
      const q = query(
        colTransactions,
        where("referral_id", "==", this.referralId),
        orderBy("created_at", "desc"),
        limit(50)
      );
      const snap = await getDocs(q);
      if (!snap.empty && snap.docs.length > this.transactionCount) {
        const rawDate = snap.docs[snap.docs.length - 1].data().created_at;
        const date = rawDate && rawDate.toDate ? rawDate.toDate() : rawDate;
        this.detectedFrom = moment(date).format("YYYY-MM-DD");
        this.form.from = this.detectedFrom;
        this.form.to = moment().format("YYYY-MM-DD");
        await this.fetchTransactions();
      }
    }
  },
};
</script>

<style></style>
